import useCurrency from './useCurrency';

// Thin wrapper kept for backward compatibility.
// New code should import useCurrency directly.
export const useCurrencyFormatter = () => {
  const { format, currency } = useCurrency();
  return { formatCurrency: format, preferredCurrency: currency };
};
